// extracted by mini-css-extract-plugin
export var container = "_51-0";
export var icon = "_51-1";
export var text = "_51-2";